var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordStrengthZwak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 5,
    viewBox: "0 0 200 5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#da4725",
    fillRule: "evenodd",
    d: "M0 0h50v5H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordStrengthZwak);
export default __webpack_public_path__ + "static/media/password-strength-zwak.dcbdcb2987da409129e46d707d052320.svg";
export { ForwardRef as ReactComponent };